import React from "react";
import { useAuthProvider, usePluginProvider, CloudPremisePluginManager } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";

import "../../styles/forgetab.scss";

const Forge = () => {
    const defaultState = {
        search: ""
    }
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    function handleChange(e, name){
        setState({
            ...state,
            [name]: e.target.value,
        });
    }
    return (
        <MDBox>
            <MDBox display="flex" justifyContent="space-between">
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDTypography variant="button" fontWeight="bold" color="dark">
                        Core Plugins
                    </MDTypography>
                </MDBox>
            </MDBox>
            <MDBox className="plugin-info" display="flex" justifyContent="space-between" p={1} mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDBox lineHeight={1.25}>
                        <MDTypography variant="button" fontWeight="light" color="dark">
                            Forge Plugin Manager
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDTypography variant="button" fontWeight="light" color="success">
                    Active
                </MDTypography>
            </MDBox>
            <MDBox className="plugin-info" display="flex" justifyContent="space-between" p={1} mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDBox lineHeight={1.25}>
                        <MDTypography variant="button" fontWeight="light" color="dark">
                            Hermes Suite
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDTypography variant="button" fontWeight="light" color="success">
                    Active
                </MDTypography>
            </MDBox>
            <MDBox className="plugin-info" display="flex" justifyContent="space-between" p={1} mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDBox lineHeight={1.25}>
                        <MDTypography variant="button" fontWeight="light" color="dark">
                            Iris Portal
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDTypography variant="button" fontWeight="light" color="success">
                    Active
                </MDTypography>
            </MDBox>
            <MDBox className="plugin-info" display="flex" justifyContent="space-between" p={1} mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDBox lineHeight={1.25}>
                        <MDTypography variant="button" fontWeight="light" color="dark">
                            Proteus Objects
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDTypography variant="button" fontWeight="light" color="success">
                    Active
                </MDTypography>
            </MDBox>
            <MDBox className="plugin-info" display="flex" justifyContent="space-between" p={1} mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDBox lineHeight={1.25}>
                        <MDTypography variant="button" fontWeight="light" color="dark">
                            Chronos BPM
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDTypography variant="button" fontWeight="light" color="success">
                    Active
                </MDTypography>
            </MDBox>
            <MDBox className="plugin-info" display="flex" justifyContent="space-between" p={1} mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDBox lineHeight={1.25}>
                        <MDTypography variant="button" fontWeight="light" color="dark">
                            Orion Threads
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDTypography variant="button" fontWeight="light" color="success">
                    Active
                </MDTypography>
            </MDBox>
            <MDBox className="plugin-info" display="flex" justifyContent="space-between" p={1} mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDBox lineHeight={1.25}>
                        <MDTypography variant="button" fontWeight="light" color="dark">
                            Eos CI/CD
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDTypography variant="button" fontWeight="light" color="success">
                    Active
                </MDTypography>
            </MDBox>
            <MDBox display="flex" justifyContent="space-between" mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDTypography variant="button" fontWeight="bold" color="dark">
                        Additional Plugins
                    </MDTypography>
                </MDBox>
            </MDBox>
            <MDBox className="plugin-info" display="flex" justifyContent="space-between" p={1} mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDBox lineHeight={1.25}>
                        <MDTypography variant="button" fontWeight="light" color="dark">
                            Functions
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDTypography variant="button" fontWeight="light" color="success">
                    Active
                </MDTypography>
            </MDBox>
            <MDBox className="plugin-info" display="flex" justifyContent="space-between" p={1} mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDBox lineHeight={1.25}>
                        <MDTypography variant="button" fontWeight="light" color="dark">
                            Network Security
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDTypography variant="button" fontWeight="light" color="success">
                    Active
                </MDTypography>
            </MDBox>
            <MDBox className="plugin-info" display="flex" justifyContent="space-between" p={1} mt={1}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDBox lineHeight={1.25}>
                        <MDTypography variant="button" fontWeight="light" color="dark">
                            Advanced Attribution
                        </MDTypography>
                    </MDBox>
                </MDBox>
                <MDTypography variant="button" fontWeight="light" color="text">
                    Not Active
                </MDTypography>
            </MDBox>
            <MDBox display="flex" justifyContent="space-between" mt={2}>
                <MDBox textAlign="left" lineHeight={1.25}>
                    <MDButton variant="outlined" color="light" sx={{textTransform: "capitalize"}}>
                        Create Your Own Plugin
                    </MDButton>
                </MDBox>
                <MDBox textAlign="right" lineHeight={1.25}>
                    <MDInput
                        name="search"
                        type="text"
                        // label="Search"
                        placeholder="Search for other Plugins..."
                        fullWidth
                        value={state.search}
                        onChange={(e) => handleChange(e, "search")}
                        required
                    />
                </MDBox>
            </MDBox>
        </MDBox>
    );
};

export default Forge;